import { useEffect, useRef } from "react";
import { useState } from "react";
import { useDispatch } from "react-redux";
import DynamicTable from "src/components/table";
import {
  columntype,
  dataLocalStorage,
  getLocalStorage,
  isValidArray,
} from "src/helper/publicFunction";
import {
  DeleteRequestReviews,
  EditRequestReviews,
  GetRequest,
  SearchRequests,
} from "./actions";
import { CommonAlert } from "src/components/alert/CommonAlert";
import { useNavigate } from "react-router";
import { FormControl, MenuItem, Select } from "@mui/material";

const Requests = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const Commonalert = CommonAlert(); // Create an alert object using the function
  const [page, setPage] = useState(0);
  const [status, setstatus] = useState("all");
  const [categorize_by, setcategorize_by] = useState("none");
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [search, setSearch] = useState("");
  const [selected, setSelected] = useState([]);
  const [loadingData, setLoadingData] = useState(true);
  const [loadingEditdatatype, setloadingEditdatatype] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [values, setvalues] = useState({});
  const [editMode, setEditMode] = useState(false);
  const [data, setData] = useState([]);
  const [meta, setMeta] = useState(null);
  const [visaTypes, setVisaTypes] = useState([]);
  const [TotalData, setTotalData] = useState(0);
  let dataPrivileges = getLocalStorage(dataLocalStorage.privileges);

  const GetData = ({ status = "all", categorize_by }) => {
    setLoadingData(true);
    setData([]);
    dispatch(
      GetRequest({
        categorize_by: categorize_by,
        status: status,
        page: page,
        rowsPerPage: rowsPerPage,
        callback: (data) => {
          if (isValidArray(data?.data)) {
            setData(data?.data);
            setMeta(data?.meta);
          } else {
            setData([]);
          }
          setLoadingData(false);
        },
      })
    );
  };

  useEffect(() => {
    GetData({
      tableName: null,
      type: null,
      status: status,
      categorize_by: categorize_by,
    });
  }, [page, rowsPerPage, search]);

  const columns = [
    { type: columntype.text, name: "id" },
    { type: columntype.image, name: "client_image" },
    { type: columntype.text, name: "client_name" },
    { type: columntype.text, name: "status" },
    { type: columntype.paymentStatus, name: "is_paid" },
    { type: columntype.text, name: "nationality" },
    { type: columntype.text, name: "destination" },
    { type: columntype.text, name: "visa_type_price_title" },
    { type: columntype.text, name: "visa_type_name" },
    { type: columntype.date, name: "created_date" },
    { type: columntype.switch, name: "is_active" },
  ];

  const headCells = [
    {
      id: "id",
      numeric: false,
      disablePadding: false,
      label: "id",
      withSort: true,
    },
    {
      id: "client_image",
      numeric: false,
      disablePadding: false,
      label: "Image",
      withSort: false,
    },
    {
      id: "client_name",
      numeric: false,
      disablePadding: false,
      label: "Client Name",
      withSort: false,
    },
    {
      id: "status",
      numeric: false,
      disablePadding: false,
      label: "Status",
      withSort: false,
    },
    {
      id: "is_paid",
      numeric: false,
      disablePadding: false,
      label: "Is Paid",
      withSort: false,
    },
    {
      id: "nationality",
      numeric: false,
      disablePadding: false,
      label: "Nationality",
      withSort: false,
    },

    {
      id: "destination",
      numeric: false,
      disablePadding: false,
      label: "Destination",
      withSort: false,
    },

    {
      id: "visa_type_price_title",
      numeric: false,
      disablePadding: false,
      label: "Visa Type (Price)",
      withSort: false,
    },
    {
      id: "visa_type_name",
      numeric: false,
      disablePadding: false,
      label: "Visa Type (Name)",
      withSort: false,
    },
    {
      id: "created_date",
      numeric: false,
      disablePadding: false,
      label: "Created date",
      withSort: true,
    },
    // {
    //   id: "is_active",
    //   numeric: false,
    //   disablePadding: false,
    //   label: "Active",
    //   withSort: true,
    // },
    (dataPrivileges["4"]?.access_edit == 1 ||
      dataPrivileges["4"]?.access_delete == 1) && {
      id: "action",
      numeric: false,
      disablePadding: false,
      label: "Action",
      withSort: false,
    },
  ];

  const List = (dataGloble) => {
    return [
      // dataPrivileges["4"]?.access_delete == 1 && {
      //   name: "Delete",
      //   function: async (row) => {
      //     if (row) {
      //       Commonalert.show({
      //         title: `Are you sure to delete ${row?.username ?? ""}?`,
      //         message: "You won't be able to revert this!",
      //         type: "delete",
      //         actions: [
      //           {
      //             name: "Yes",
      //             callback: () =>
      //               dispatch(
      //                 DeleteRequestReviews({
      //                   callback: () => {
      //                     GetData({ tableName: null, type: null });
      //                   },
      //                   id: row.id,
      //                 })
      //               ),
      //             type: "delete",
      //           },
      //           {
      //             name: "No",
      //             callback: () => {},
      //             type: "cancel",
      //           },
      //         ],
      //       });
      //     }
      //   },
      // },
      dataPrivileges["4"]?.access_delete == 1 && {
        name: "Details",
        function: async (row) => {
          if (row) {
            navigate(`/request/${row.id}`);
          }
        },
      },
    ];
  };

  const updateDataApi = ({ row, failedName, newData }) => {
    setloadingEditdatatype(`${row?.id}-${failedName}`);
    dispatch(
      EditRequestReviews({
        id: row?.id,
        dataFailed: newData,
        nameFailed: failedName,
        callback: () => {
          updateDataLocal({ id: row.id, failedName, newData });
        },
      })
    );
  };

  const updateDataLocal = ({ id, failedName, newData }) => {
    setData((prevData) => {
      return prevData.map((item) => {
        if (item.id === id) {
          return {
            ...item,
            [failedName]: newData,
          };
        }
        return item;
      });
    });
    setloadingEditdatatype("");
  };
  console.log({ data__123: data });

  const debounceRef = useRef(null);

  const handleSearch = (event) => {
    const value = event.target.value;
    setSearch(value);

    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
    }

    debounceRef.current = setTimeout(() => {
      if (value === "" || !value) {
        return;
      }

      dispatch(
        SearchRequests({
          search: value, // Use latest value directly
          callback: (data) => {
            console.log({ data123123: data });
            if (data) {
              setData(data?.data);
            }
          },
        })
      );
    }, 1000);
  };

  return (
    <>
      <FormControl>
        <Select
          sx={{ ml: 2 }}
          disabled={loadingData}
          inputProps={{ "aria-label": "Without label" }}
          displayEmpty
          value={status}
          defaultValue={status}
          onChange={(e) => {
            setPage(0);
            setstatus(e.target.value);
            GetData({ status: e.target.value, categorize_by: categorize_by });
            // setTimeout(() => {
            //   alert(page);
            // }, 500);
          }}
        >
          <MenuItem value="all">All</MenuItem>
          <MenuItem value="pending">Pending</MenuItem>
          <MenuItem value="approved">Approved</MenuItem>
          <MenuItem value="rejected">Rejected</MenuItem>
          <MenuItem value="under_review">Under Review</MenuItem>
          <MenuItem value="expired">Expired</MenuItem>
          <MenuItem value="cancelled">Cancelled</MenuItem>
          <MenuItem value="incomplete">Incomplete</MenuItem>
        </Select>
      </FormControl>
      <FormControl>
        <Select
          sx={{ ml: 2 }}
          disabled={loadingData}
          inputProps={{ "aria-label": "Without label" }}
          displayEmpty
          value={categorize_by}
          defaultValue={categorize_by}
          onChange={(e) => {
            setcategorize_by(e.target.value);
            GetData({ status: status, categorize_by: e.target.value });
          }}
        >
          <MenuItem value="none">None</MenuItem>
          <MenuItem value="week">This Week</MenuItem>
          <MenuItem value="month">This Month</MenuItem>
          <MenuItem value="year">This Year</MenuItem>
        </Select>
      </FormControl>
      <DynamicTable
        handleSearch={handleSearch} // call api
        onRequestSort={(tableName, type) => {
          if (tableName && type) {
            GetData({ tableName, type });
          }
        }} // call api
        onPressDelete={(ListIds) => {
          console.log({ ListIds_123: ListIds });
          Commonalert.show({
            title: "Are you sure?",
            message: "You won't be able to revert this!",
            type: "delete",
            actions: [
              {
                name: "Yes",
                callback: () =>
                  dispatch(
                    DeleteRequestReviews({
                      callback: () => {
                        GetData({ tableName: null, type: null });
                      },
                      id: ListIds,
                    })
                  ),
                type: "delete",
              },
              {
                name: "No",
                callback: () => {},
                type: "cancel",
              },
            ],
          });
        }} // call api
        onPressItem={(row) => {}} // when press item
        onPressAnyAction={(row, failedName, newData) => {
          updateDataApi({ row, failedName, newData });
        }} // when press checkbox or switch
        onPressAdd={() => {
          setvalues({});
          setEditMode(false);
          setShowModal(true);
        }} // when press add new button show modal to add new item
        items={data} // all data
        columns={columns} // type of data
        headCells={headCells} // columns name
        page={page} // number of page from api
        setPage={setPage} // set number of page from api
        selected={selected} // selected items
        setSelected={setSelected} // set selected items
        search={search} // search failed
        rowsPerPage={rowsPerPage} // number show Data
        setRowsPerPage={setRowsPerPage} // set number show data
        Listdropdown={(row) => List(row)} // list action with function
        withOption={true} // for remove action column
        loadingData={loadingData} // when load data from api
        rowsPerPageOptions={[5, 10, 25, 50]} // set option number of show data
        totalItem={meta?.total} // total data without pagination
        loadingEditdatatype={loadingEditdatatype} // first failed (id) and second (failed Name) like ={"1-is_active"}
        withAddButton={false}
        withDeleteItem={false}
        withEditItem={dataPrivileges["4"]?.access_edit == 1 ? true : false}
        withPagination={true}
        withSearch={true}
      />
    </>
  );
};

export default Requests;
